export { Acordo } from './models/acordo';
export { LoteHonorario } from './models/lote-honorario';
export { LoteFatura } from './models/lote-fatura';
export { Devedor } from './models/devedor';
export { ContaCredito } from './models/conta-credito';
export { Banco } from './models/banco';
export { ExtratoContaCredito } from './models/extrato-conta-credito';
export { LinhaExtratoContaCredito } from './models/linha-extrato-conta-credito';
export { TransacaoCredito } from './models/transacao-credito';
export { StatusTransacaoCredito } from './models/status-transacao-credito';
export { StatusLinhaCredito } from './models/status-linha-credito';
export { ArquivoComprovanteContaCredito } from './models/arquivo-comprovante-conta-credito';
export { FiltroConciliacao } from './models/filtro-conciliacao';
export { FiltroAcordo } from './models/filtro-acordo';
export { ComprovanteContaCredito } from './models/comprovante-conta-credito';
export { Usuario } from './models/usuario';
export { TipoPessoa } from './models/tipo-pessoa';
export { NaturezaJuridica } from './models/natureza-juridica';
export { Pessoa } from './models/pessoa';
export { Congenere } from './models/congenere';
export { CategoriaDevedor } from './models/categoria-devedor';
export { Escritorio } from './models/escritorio';
export { Endereco } from './models/endereco';
export { Telefone } from './models/telefone';
export { Logradouro } from './models/logradouro';
export { TipoEnderecamentoPostal } from './models/tipo-enderecamento-postal';
export { TipoLogradouro } from './models/tipo-logradouro';
export { Localidade } from './models/localidade';
export { TipoLocalidade } from './models/tipo-localidade';
export { Estado } from './models/estado';
export { Pais } from './models/pais';
export { TipoFinalidadeTelefone } from './models/tipo-finalidade-telefone';
export { Parcela } from './models/parcela';
export { Auditoria } from './models/auditoria';
export { ProcedenciaAcordo } from './models/procedencia-acordo';
export { TipoRecebimento } from './models/tipo-recebimento';
export { TipoOrigemAcordo } from './models/tipo-origem-acordo';
export { TipoParcela } from './models/tipo-parcela';
export { TipoEnvioBoleto } from './models/tipo-envio-boleto';
export { SituacaoLote } from './models/situacao-lote';
export { SituacaoAcordo } from './models/situacao-acordo';
export { TipoSituacaoParcelaAcordo } from './models/tipo-situacao-parcela-acordo';
export { ProcessoRessarcimento } from './models/processo-ressarcimento';
export { FormaPagamento } from './models/forma-pagamento';
export { HonorarioFlutuante } from './models/honorario-flutuante';
export { PerfilSelecionadoAlcadaAuto } from './models/perfil-selecionado-alcada-auto';
export { PerfilSelecionadoAlcadaFiancaLocaticia } from './models/perfil-selecionado-alcada-fianca-locaticia';
export { ValoresEscolhido } from './models/valores-escolhido';
export { EmailType } from './models/email-type';
export { RequestDSSapType } from './models/request-dssap-type';
export { RequestCancelamentoPropostaType } from './models/request-cancelamento-proposta-type';
export { RequestAprovacaoPropostaType } from './models/request-aprovacao-proposta-type';
export { RequestReprocessarBoletoType } from './models/request-reprocessar-boleto-type';
export { RequestCancelamentoSAPType } from './models/request-cancelamento-saptype';
export { RequestAlteracaoDataParcelaSAPType } from './models/request-alteracao-data-parcela-saptype';
export { RequestRecusarTransacaoType } from './models/request-recusar-transacao-type';
export { RequestValidarTransacaoType } from './models/request-validar-transacao-type';
export { RequestLoteHonorarioType } from './models/request-lote-honorario-type';
export { RetornoDSSapType } from './models/retorno-dssap-type';
export { DadosCalculoDivida } from './models/dados-calculo-divida';
export { SumarizacaoAcordo } from './models/sumarizacao-acordo';
export { AcordoPaginado } from './models/acordo-paginado';
export { LoteFaturaPaginado } from './models/lote-fatura-paginado';
export { LoteHonorarioPaginado } from './models/lote-honorario-paginado';
export { ParcelaPaginado } from './models/parcela-paginado';
export { LinhaExtratoContaCreditoPaginado } from './models/linha-extrato-conta-credito-paginado';
export { TransacaoCreditoPaginado } from './models/transacao-credito-paginado';
export { ParcelaLista } from './models/parcela-lista';
export { RetornoLogradouro } from './models/retorno-logradouro';
export { RetornoLogradouros } from './models/retorno-logradouros';
export { ProcedenciaAcordoPaginado } from './models/procedencia-acordo-paginado';
export { TipoRecebimentoPaginado } from './models/tipo-recebimento-paginado';
export { TipoOrigemAcordoPaginado } from './models/tipo-origem-acordo-paginado';
export { TipoParcelaPaginado } from './models/tipo-parcela-paginado';
export { TipoEnvioBoletoPaginado } from './models/tipo-envio-boleto-paginado';
export { TipoSituacaoParcelaAcordoPaginado } from './models/tipo-situacao-parcela-acordo-paginado';
export { Paginacao } from './models/paginacao';
export { Message } from './models/message';
export { AcordoResponse } from './models/acordo-response';
export { PropostaResponse } from './models/proposta-response';
export { LoteResponse } from './models/lote-response';
export { TransacaoResponse } from './models/transacao-response';
export { BoletoRequest } from './models/boleto-request';
export { DadosLinhaTempoAcordo } from './models/dados-linha-tempo-acordo';
export { DadosErroSAP } from './models/dados-erro-sap';
export { Dinamica } from './models/dinamica';
export { ScoreSerasa } from './models/score-serasa';
export { TipoPessoaEnum } from './models/tipo-pessoa-enum';
export { SexoEnum } from './models/sexo-enum';
export { TipoLinhaTelefonicaEnum } from './models/tipo-linha-telefonica-enum';
export { TipoCalculoDividaEnum } from './models/tipo-calculo-divida-enum';
export { SimbolosEnum } from './models/simbolos-enum';
export { PerfilEnum } from './models/perfil-enum';
